import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { parseSearch } from "../../../actions/helpers";
import { setAnalysisType } from "../../../actions/filters";

const PREFIX = 'AnalysisType';

const classes = {
  root: `${PREFIX}-root`,
  formControl: `${PREFIX}-formControl`,
  selectEmpty: `${PREFIX}-selectEmpty`,
  menuItem: `${PREFIX}-menuItem`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.formControl}`]: {
    margin: theme.spacing(1),
    minWidth: "12rem",
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: "#fff",
      padding: "0 0.7em",
    },
  },

  [`& .${classes.menuItem}`]: {
    textTransform: "capitalize",
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AnalysisType = ({ analysisType, setAnalysisType }) => {

  const history = useHistory();
  const filter = Object.keys(analysisType).filter((key) => analysisType[key]);

  const setHistory = (key, param) => {
    const searchParams = parseSearch();
    param.length === 0 ? delete searchParams[key] : (searchParams[key] = param);
    const params = new URLSearchParams(searchParams).toString();
    const search = params.includes("?") ? `${params}` : `?${params}`;
    history.push({
      pathname: "/details",
      search: search,
    });
  };

  const handleChange = (event) => {
    const _analysisType = {};
    const values = event.target.value;
    Object.keys(analysisType).map((key) => (_analysisType[key] = false));
    values.map((val) => (_analysisType[val.toLowerCase()] = true));
    setAnalysisType(_analysisType);
    setHistory("analysisType", `${values}`);
  };

  useEffect(() => {
    if (!parseSearch().analysisType) {
      setHistory(
        "analysisType",
        `${Object.keys(analysisType).filter((key) => analysisType[key])}`
      );
    }
  }, [analysisType]);

  return (
    <Root className={classes.root}>
		<div>
	      <FormControl className={classes.formControl}>
	        <InputLabel>Analysis Type Filter</InputLabel>
	        <Select
	          multiple
	          value={filter}
	          onChange={handleChange}
	          input={<Input />}
	          renderValue={(selected) => selected.join(", ")}
	          MenuProps={MenuProps}
	        >
	          {Object.keys(analysisType).map((val) => (
	            <MenuItem className={classes.menuItem} key={val} value={val}>
	              <Checkbox checked={filter.indexOf(val) > -1} />
	              <ListItemText primary={val} />
	            </MenuItem>
	          ))}
	        </Select>
	      </FormControl>
		</div>
    </Root>
  );
};

AnalysisType.propTypes = {
  setAnalysisType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  analysisType: state.filters.analysisType,
});

export default connect(mapStateToProps, { setAnalysisType })(AnalysisType);
